import loadable from '@loadable/component';

export const LazyEmailPreferences = loadable(() => import(/* webpackChunkName: "content/emailpreferences" */ '.'));
